import { render, staticRenderFns } from "./content3.vue?vue&type=template&id=a9365a78&scoped=true"
import script from "./content3.vue?vue&type=script&lang=js"
export * from "./content3.vue?vue&type=script&lang=js"
import style0 from "./content3.vue?vue&type=style&index=0&id=a9365a78&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9365a78",
  null
  
)

export default component.exports